import { Badge, type BadgeProps } from '@chakra-ui/react';

export type UiBadgeProps = BadgeProps;

export const UiBadge = Badge;
